<template>
  <div>
    <div class="text-xs-right">
      <div>ชื่อลูกค้า : {{ data.name }}</div>
      <div>เบอร์ติดต่อ : {{ data.phonenumber }}</div>
      <div>PC : {{ data.pcname }}</div>
    </div>
    <div>
      <div style="font-weight: 700">รายการสินค้า</div>
      <div v-for="(product, index) in data.productdetails" :key="index">
        <div>{{ index + 1 }}.</div>
        <div v-for="(val, k) in product" :key="k">
          <div v-if="val && !isArrayProductPhoto.includes(k)">
            <div v-if="!isHidden.includes(k)">{{ topicText(k) }} : {{ val }}</div>
          </div>
          <div v-else>
            <div v-for="(photo, i) in val" :key="i" class="mb-4">
              <section>
                <img
                  crossorigin="Anonymous"
                  :src="photo + '?not-from-cache-please&cacheblock=true'"
                  style="max-width: 500px; max-height: 500px; object-fit: contain"
                />
              </section>
            </div>
          </div>
        </div>
      </div>

      <!-- <div v-for="(product,index) in data.productdetails" :key="index">
        <div v-for="(val,k) in product" :key="k">
          <div v-if="val && isArrayProductPhoto.includes(k) && val.length > 0">
            <div v-for="(photo,i) in val" :key="i" class="mb-4">
              <section>
                <img crossorigin="Anonymous" :src="photo+'?not-from-cache-please&cacheblock=true'" style="max-width: 500px; max-height: 500px; object-fit: contain;"/>
              </section>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <section class="mt-4" v-if="data.jobsiteimages">
      <div>
        <div style="font-weight: 700" class="mb-2">รูปหน้างาน</div>
        <div v-for="(arrImage, title) in data.jobsiteimages" :key="title">
          <template v-if="arrImage && arrImage.length > 0">
            <section class="my-2">
              <div class="mb-2" style="font-weight: 600">{{ topicText(title) }} :</div>
              <div v-for="(image, k) in arrImage" :key="k">
                <section>
                  <img
                    crossorigin="Anonymous"
                    :src="image + '?not-from-cache-please&cacheblock=true'"
                    style="max-width: 500px; max-height: 500px; object-fit: contain"
                  />
                </section>
              </div>
            </section>
          </template>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      isArrayProductPhoto: [
        'photos',
        'simplePhotoDrillSink',
        'simplePhotoDrillStove',
        'simpleSmoothSink'
      ],
      isHidden: ['HasDrillSink', 'HasDrillStove'],
      translateText: [
        {
          en: 'product',
          th: ''
        },
        {
          en: 'drilStoveOption',
          th: 'เจาะเตา'
        },
        {
          th: 'เจาะซิงค์',
          en: 'drilSinkOption'
        },
        {
          en: 'sink',
          th: 'ซิงค์'
        },
        {
          en: 'format',
          th: 'รูปแบบการติดตั้ง'
        },
        {
          en: 'other',
          th: 'อุปกรณ์อื่นๆ'
        },
        {
          en: 'other',
          th: 'หมายเหตุ'
        },
        {
          en: 'left',
          th: 'ภาพโดยรวมด้านซ้าย'
        },
        {
          en: 'front',
          th: 'ด้านหน้า ระยะห่างระหว่างท่อกับเสา'
        },
        {
          en: 'right',
          th: 'ด้านขวา'
        },
        {
          en: 'sewer',
          th: 'ตำแหน่งท่อน้ำทิ้งและน้ำดี ความสูงของพื้น และระยะห่างจากผนัง'
        },
        {
          en: 'pile',
          th: 'ขนาดของเสา ด้านซ้าย และขวา'
        },
        {
          en: 'window',
          th: 'ขนาดและตำแหน่งของหน้าต่าง'
        },
        {
          en: 'plug',
          th: 'ตำแหน่งของปลั๊กไฟและประตู'
        },
        {
          en: 'lotus',
          th: 'ความสูงของบัวจากพื้น'
        },
        {
          en: 'pellicle',
          th: 'ความสูงของพื้นถึงด้านบนฝ้า'
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$emit('domRendered')
      }, 1000)
    })
  },
  methods: {
    topicText(text) {
      let translateText = this.translateText

      var isThText = translateText.filter((obj) =>
        Object.keys(obj).some((key) => obj[key].includes(text))
      )

      if (isThText.length > 0) {
        return isThText[0].th
      } else {
        return text
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pdf-content {
  width: 100%;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/adminMenu/PrintContentDetail.vue